import { ActionEntityType } from '@pmp/api';
import { productsColumns } from '../products';
import { baseRateColumns } from '../baseRates';
import { ercProfilesFlatColumns } from '../ercProfiles';
import { feeProfilesColumns, feesColumns } from '../fees';
import { TableColumns } from '@ohpen/enso-ui';
import { DataTypeForEntity } from './interfaces';
import { exchangeRateExportColumns } from '../exchangeRates';
import { exclusiveSetsColumns } from '../exclusiveProducts';
import { firmExportColumns } from '../firms';
import { intermediaryColumns } from '../brokers';

export const getColumnsSchema = <T extends ActionEntityType>(entityType: T): TableColumns<DataTypeForEntity<T>> => {
  const columnsSchemaByEntity: Partial<Record<ActionEntityType, TableColumns<any>>> = {
    [ActionEntityType.PRODUCTS]: productsColumns,
    [ActionEntityType.BASE_RATES]: baseRateColumns,
    [ActionEntityType.ERC_PROFILES]: ercProfilesFlatColumns,
    [ActionEntityType.FEES]: feesColumns,
    [ActionEntityType.FEE_PROFILES]: feeProfilesColumns,
    [ActionEntityType.EXCHANGE_RATES]: exchangeRateExportColumns,
    [ActionEntityType.EXCLUSIVITY_SETS]: exclusiveSetsColumns,
    [ActionEntityType.FIRMS]: firmExportColumns,
    [ActionEntityType.BROKERS]: intermediaryColumns.filter(column => column.key !== 'actions'),
  };

  return columnsSchemaByEntity[entityType] as TableColumns<DataTypeForEntity<T>>;
};
